import { Input, FormGroup, Modal, ModalBody } from "reactstrap";
// import { initFirebaseBackend } from "helpers/firebase_helper";
import {
  RecaptchaVerifier,
  signInWithPhoneNumber,
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import auth from "../../store/guest_user/helper";
import { useContext, useEffect, useState, useCallback } from "react";
import PhoneInput from "react-phone-number-input";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import useSWR from "swr";
import { GET_OPEN_USER_LOCATION } from "helpers/jiraya_url";
import { getOpenUserLocation } from "helpers/jiraya_helper";
import { UserProvider } from "store/guest_user/userContext";
import UserContext from "store/guest_user/userContext";
import { toast } from "react-toastify";
import CompleteProfile from "components/Events/Client/Auth/CompleteProfile";
import { patchGuestUserProfile } from "helpers/jiraya_helper";
import { getGuestUser } from "helpers/jiraya_helper";
import CartAuthHandler from "components/PhotoSelling/CartAuthHandler";

const Login = () => {
  const { t } = useTranslation();
  useEffect(() => {
    let registeredData = localStorage.getItem("registration-data");
    if (registeredData) {
      registeredData = JSON.parse(registeredData);
      setMobileNumber(registeredData.mobile_number);
    }
  }, []);
  const [confirmationResult, setConfirmationResult] = useState();
  const [isCaptchaOK, setIsCaptchaOK] = useState(false);
  const [otp, setOtp] = useState();
  const handleChangeOTP = (v) => {
    setOtp(v);
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { handleSetUser } = useContext(UserContext);

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      try {
        if (isMounted) {
          if (auth && !confirmationResult) {
            window.recaptchaVerifier = new RecaptchaVerifier(
              auth,
              "recaptcha-container",
              {
                size: "invisible",
                callback: function (_response) {
                  console.debug(_response);
                  onValidCaptcha();
                },
                "expired-callback": function () {
                  // Response expired. Ask user to solve reCAPTCHA again.
                  // updateSignInButtonUI();
                  console.debug("expire");
                },
              }
            );

            window.recaptchaVerifier.render().then(function (widgetId) {
              window.recaptchaWidgetId = widgetId;
            });
            window.recaptchaVerifier.verify().then((response) => {
              console.debug(response);
            });
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error(error);
        }
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  const [mobileNumber, setMobileNumber] = useState();
  const onMobilInputChange = (val) => {
    setMobileNumber(val);
    // setErrorMessages({ ...errorMessages, mobileNumber: null });
  };
  const handleOnChangeMobile = () => {
    setOtp();
    setMobileNumber();
    setConfirmationResult();
  };

  const handleOnVerifyOTP = (otp) => {
    setIsSubmitting(true);
    confirmationResult
      .confirm(otp)
      .then((response) => {
        toast.success(t("OTP Verified Successfully"));
        handleSetUser(response.user);
      })
      .catch((err) => {
        setIsSubmitting(false);
        setOtp("");
        console.error(err);
        toast.error(err.code);
      });
  };

  const handleOnGetOTP = () => {
    const appVerifier = window.recaptchaVerifier;
    setIsSubmitting(true);
    signInWithPhoneNumber(auth, mobileNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        setConfirmationResult(confirmationResult);
        toast.success(t("OTP sent successfully"));
        setIsSubmitting(false);
        // ...
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          t("Failed to send OTP, error code {{code}}", { code: error.code })
        );
        setConfirmationResult();
        // Error; SMS not sent
        // ...
        setIsSubmitting(false);
      });
  };
  const onValidCaptcha = () => {
    setIsCaptchaOK(true);
  };

  return (
    <>
      <div className="w-100 text-center login">
        <div>
          <strong className=" ">{t("Sign In to Continue")}</strong>
        </div>

        <small>
          {t("Verify your mobile number to continue uploading photos")}
        </small>
      </div>
      {mobileNumber && confirmationResult ? (
        <VerifyOTP
          handleOnVerifyOTP={handleOnVerifyOTP}
          mobileNumber={mobileNumber}
          handleChangeOTP={handleChangeOTP}
          otp={otp}
          isSubmitting={isSubmitting}
          handleOnChangeMobile={handleOnChangeMobile}
          handleOnGetOTP={handleOnGetOTP}
        />
      ) : (
        <GetOTP
          mobileNumber={mobileNumber}
          onMobilInputChange={onMobilInputChange}
          isCaptchaOK={isCaptchaOK}
          handleOnGetOTP={handleOnGetOTP}
          isSubmitting={isSubmitting}
        />
      )}
      <div className="mt-4 d-flex justify-content-center flex-column align-items-center">
        <div id="recaptcha-container"></div>
      </div>
    </>
  );
};

const VerifyOTP = ({
  handleOnVerifyOTP,
  mobileNumber,
  otp,
  handleChangeOTP,
  isSubmitting,
  handleOnChangeMobile,
  handleOnGetOTP,
}) => {
  const { t } = useTranslation();
  const [resendTimer, setResendTimer] = useState(30);
  const handleOnResendOTP = () => {
    setResendTimer(30);
    handleOnGetOTP();
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      setResendTimer((p) => {
        const newT = p - 1;
        if (newT <= 0) {
          clearInterval(intervalId);
        }
        return newT;
      });
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <>
      <FormGroup>
        <div className="mt-2">
          {mobileNumber}
          <i className="mdi mdi-pencil ms-1" onClick={handleOnChangeMobile} />
        </div>
      </FormGroup>
      <FormGroup>
        <Input
          // type="password"
          pattern="[0-9]*"
          inputMode="numeric"
          className="pin-input mt-4"
          maxLength={6}
          min={0}
          max={999999}
          onChange={(e) => handleChangeOTP(e.target.value)}
          value={otp}
          // disabled={isSubmitting}
        />
      </FormGroup>
      {resendTimer === 0 ? (
        <small
          onClick={handleOnResendOTP}
          style={{ textDecoration: "underline" }}
        >
          {t("Resend OTP")}
        </small>
      ) : (
        <small>
          {t("resend OTP in {{seconds}}s", { seconds: resendTimer })}
        </small>
      )}

      <div className="px-2 w-100 mt-3">
        <button
          // ref={signInButtonRef}
          id="sign-in-button"
          className="btn btn-fotoowl btn-rounded-2 mt-2 px-4 w-100"
          disabled={isSubmitting || !otp || otp.length != 6}
          onClick={() => {
            handleOnVerifyOTP(otp);
          }}
        >
          {t("Verify")}
        </button>
      </div>
    </>
  );
};

const GetOTP = ({
  mobileNumber,
  onMobilInputChange,
  handleOnGetOTP,
  isCaptchaOK,
  isSubmitting,
}) => {
  const { t } = useTranslation();
  const { data: countryData } = useSWR(
    GET_OPEN_USER_LOCATION,
    getOpenUserLocation
  );

  return (
    <div className="mt-3 px-2 ">
      <PhoneInput
        placeholder={t("Enter Mobile Number")}
        value={mobileNumber}
        // onCountryChange={handleOnCountryChange}
        onChange={onMobilInputChange}
        defaultCountry={countryData?.data?.country}
        numberInputProps={{
          className: classNames("form-control mobile-number"),
        }}
      />
      <div className="w-100 mt-3 text-center">
        <button
          // ref={signInButtonRef}
          id="sign-in-button"
          className="btn btn-fotoowl btn-rounded-2 mt-2 px-4 w-100"
          onClick={handleOnGetOTP}
          disabled={!isCaptchaOK || isSubmitting}
        >
          {t("Get OTP")}
        </button>
        <small className="">
          {t("check your message inbox or wait for 1-2 mins")}{" "}
        </small>
      </div>
    </div>
  );
};

const GoogleAuth = ({ onCancelCallback }) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  useContext(UserContext);
  const googleProvider = new GoogleAuthProvider();
  const cartAuthHandler = CartAuthHandler();

  const handleGoogleSignIn = async () => {
    setIsSubmitting(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      await cartAuthHandler.handleAuthSuccess(result.user);
      await patchGuestUserProfile({
        name: result.user.displayName,
        email_id: result.user.email,
      });
      // Close the modal after successful authentication
      if (onCancelCallback) {
        onCancelCallback();
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="w-100 text-center login">
        <div>
          <strong>{t("Sign In with Google")}</strong>
        </div>
        <small>{t("Continue with your Google account")}</small>
      </div>
      <div className="mt-3 px-2">
        <button
          className="btn btn-fotoowl btn-rounded-2 mt-2 px-4 w-100"
          onClick={handleGoogleSignIn}
          disabled={isSubmitting}
        >
          {isSubmitting ? t("Signing in...") : t("Continue with Google")}
        </button>
      </div>
    </>
  );
};

const LoginModal = ({ isOpen, onCancelCallback }) => {
  return (
    <Modal isOpen={isOpen} centered size="md" zIndex={1503}>
      <ModalBody className="p-3">
        <div className="d-flex justify-content-end">
          <button
            className="btn-close"
            onClick={() => {
              onCancelCallback();
            }}
          />
        </div>

        <Login />
      </ModalBody>
    </Modal>
  );
};

const GoogleAuthModal = ({ isOpen, onCancelCallback }) => {
  return (
    <Modal isOpen={isOpen} centered size="md" zIndex={1503}>
      <ModalBody className="p-3">
        <div className="d-flex justify-content-end">
          <button
            className="btn-close"
            onClick={() => {
              onCancelCallback();
            }}
          />
        </div>
        <GoogleAuth onCancelCallback={onCancelCallback} />
      </ModalBody>
    </Modal>
  );
};

const CompleteProfileModal = ({ isOpen }) => {
  return (
    <Modal isOpen={isOpen} centered size="md" zIndex={1505}>
      <ModalBody className="p-3">
        <CompleteProfile />
      </ModalBody>
    </Modal>
  );
};

const User = ({ children }) => {
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const [isUserLoading, setIsUserLoading] = useState(true);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openGoogleAuthModal, setOpenGoogleAuthModal] = useState(false);
  const [openCompleteProfileModal, setOpenCompleteProfileModal] =
    useState(false);
  const handleSetUser = (_user) => {
    if (_user) {
      getGuestUser().then((response) => {
        if (response.ok) {
          const userData = { ..._user, ...response.data };
          setUser(userData);
          handleOnCloseLoginModal();
        } else {
          setUser();
        }
      });
    } else {
      setUser();
    }
    setIsUserLoading(false);
  };
  const [onCancelCallback, setOnCancelCallback] = useState(() => {});

  const handleOnCloseLoginModal = () => {
    setOpenLoginModal(false);
  };

  const handleOpenLoginModal = useCallback((onCancelCallback) => {
    const handleOnCloseLoginModal = () => {
      setOpenLoginModal(false);
      if (onCancelCallback) {
        onCancelCallback();
      }
    };
    setOnCancelCallback(() => handleOnCloseLoginModal);
    setOpenLoginModal(true);
  }, []);

  const handleOpenGoogleAuthModal = useCallback((onCancelCallback) => {
    const handleOnCloseGoogleAuthModal = () => {
      setOpenGoogleAuthModal(false);
      if (onCancelCallback) {
        onCancelCallback();
      }
    };
    setOnCancelCallback(() => handleOnCloseGoogleAuthModal);
    setOpenGoogleAuthModal(true);
  }, []);

  useEffect(() => {
    if (user) {
      handleOnCloseLoginModal();
      // Only open CompleteProfileModal if user doesn't have a name AND is not from Google Auth
      // Google Auth users typically have displayName, so we check for that
      if (!user.name && !user.displayName) {
        setOpenCompleteProfileModal(true);
      }
    }
  }, [user]);

  const handleOnUpdateProfile = async (userProfile) => {
    // updateProfile(auth.currentUser, {
    //   displayName: userProfile.name,
    // })
    // .then(async () => {
    try {
      const response = await patchGuestUserProfile(userProfile);
      if (response.ok) {
        toast.success(t("Profile Updated Successfully"));
        setOpenCompleteProfileModal(false);
      } else {
        toast.error(response.message);
        setOpenCompleteProfileModal(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(t("Failed to Update Profile"));
    }
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      handleSetUser(user);
    });
  }, []);

  const handleLogoutUser = () => {
    return new Promise((resolve, reject) => {
      signOut(auth)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  };
  return (
    <UserProvider
      value={{
        isUserLoading,
        user,
        setUser,
        handleSetUser,
        handleLogoutUser,
        openLoginModal,
        handleOpenLoginModal,
        handleOpenGoogleAuthModal,
        handleOnUpdateProfile,
      }}
    >
      <LoginModal isOpen={openLoginModal} onCancelCallback={onCancelCallback} />
      <GoogleAuthModal
        isOpen={openGoogleAuthModal}
        onCancelCallback={onCancelCallback}
      />
      <CompleteProfileModal isOpen={openCompleteProfileModal} />
      {children}
    </UserProvider>
  );
};

export { User };
export default LoginModal;
